import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import { Product } from '@spartacus/core';
import { ProductListItemContext, ProductListItemContextSource, ProductListOutlets } from '@spartacus/storefront';

@Component({
  selector: 'custom-product-list-item',
  standalone: false,
  templateUrl: './custom-product-list-item.component.html',
  styleUrls: ['./custom-product-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    ProductListItemContextSource,
    {
      provide: ProductListItemContext,
      useExisting: ProductListItemContextSource,
    },
  ],
})
export class CustomProductListItemComponent {
  readonly ProductListOutlets = ProductListOutlets;
  @Input() product!: Product;

  constructor(protected productListItemContextSource: ProductListItemContextSource) {}

  ngOnChanges(changes?: SimpleChanges): void {
    if (changes?.['product']) {
      this.productListItemContextSource.product$.next(this.product);
    }
  }
}
